import { RouteConfig } from 'vue-router'
import { Service } from 'typedi'
import { RouteDefinition, routeToken } from '@/services'
import { NewsEditor, NewsList, NewsOverview } from '@/customer-portal'

@Service({ id: routeToken, multiple: true })
export class NewsRoutes implements RouteDefinition {
    public getRouteConfig(): RouteConfig {
        return {
            path: '/news',
            component: NewsOverview,
            children: [
                {
                    path: ':id',
                    component: NewsEditor,
                    props: true
                },
                {
                    path: '/',
                    component: NewsList,
                    meta: { entity: 'news' }
                }
            ],
            props: true
        }
    }
}
